import { MARQUEE_LOGOS } from "@/lib/content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MARQUEE_LOGOS.map((l, i) => (
      <span key={i} className="flex items-center">
        <img src={l.src} alt={hidden ? "" : l.alt} className={`mx-10 w-auto shrink-0 object-contain md:mx-16 ${l.cls}`} draggable={false} />
        <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 opacity-60 md:h-5 md:w-5" aria-hidden><path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" fill="#FFFFFF" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden bg-trident py-6 md:py-8">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
      <Row hidden />
      <Row hidden />
    </div>
  </div>
);
